/**
 * FYLLR — Cancellation-policy short-form for in-app messaging.
 *
 * This is a VERBATIM lift from Section 4 of the Terms (see /app/legal/terms.md).
 * Use this constant everywhere cancellation/refund copy appears — checkout dialog,
 * booking confirmation screen, transactional emails. Do NOT re-word or paraphrase
 * in individual places; if the wording needs to change, change Section 4 and this
 * constant together.
 */

export const CANCEL_POLICY_SHORT =
  "Bookings are final-sale. FYLLR does not offer refunds or credits for change-of-mind cancellations or no-shows once a booking is confirmed and paid. If a Partner Salon is unable to honour a confirmed booking, FYLLR will provide a full refund or rebooking assistance.";

export const CANCEL_POLICY_TAGLINE = "Final-sale booking · Section 4 of the Terms";
